import { LoadScriptResolver, LoadCssResolver } from '@b2b/common/resolvers';
import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const MembershipCategoriesCreateView = angular
  .module('acme.view.application.membership.categories.create', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.view.application.membership.categories.create.controllers',
    'acme.view.application.membership.categories.create.description',
    'acme.view.application.membership.categories.create.email',
    'acme.view.application.membership.categories.create.mapping',
    'acme.view.application.membership.categories.create.pricing',
    'acme.view.application.membership.categories.create.rules',
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const membershipCategoriesCreate = {
      name: 'application.membership.categories.create',
      url: '/create',
      views: {
        'subview-main@application.membership': {
          controller: 'MembershipCategoriesCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/categories/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'Membership - Category',
        permissions: ['MEMBERSHIP_CATEGORY_CREATE'],
        enablePreferences: false,
      },
      resolve: {
        CategoryData: [
          function () {
            return null;
          },
        ],
        bootstrap: LoadScriptResolver({ id: 'bootstrap-js', url: '/assets/bootstrap.min.js' }),
        summernote: LoadScriptResolver({ id: 'summernote-js', url: '/assets/summernote.min.js' }),
        summernoteCss: LoadCssResolver({ id: 'summernote', url: '/assets/summernote.css' }),
      },
    };

    const membershipCategoriesEdit = {
      name: 'application.membership.categories.edit',
      url: '/:id/edit',
      views: {
        'subview-main@application.membership': {
          controller: 'MembershipCategoriesCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/categories/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'Membership - Category',
        permissions: ['MEMBERSHIP_CATEGORY_UPDATE'],
        enablePreferences: false,
      },
      resolve: {
        CategoryData: [
          '$stateParams',
          'ApiService',
          function ($stateParams, ApiService) {
            const id = $stateParams.id;
            return ApiService.membership.categories.detail(id);
          },
        ],
        bootstrap: LoadScriptResolver({ id: 'bootstrap-js', url: '/assets/bootstrap.min.js' }),
        summernote: LoadScriptResolver({ id: 'summernote-js', url: '/assets/summernote.min.js' }),
        summernoteCss: LoadCssResolver({ id: 'summernote', url: '/assets/summernote.css' }),
      },
    };

    $stateProvider.state(membershipCategoriesCreate).state(membershipCategoriesEdit);
  }).name;
